<template>
  <div class="em-showroom-card-sp">
    <div class="inner" :class="isDark ? 'is-dark' : 'is-light'">
      <div class="text" :class="{ 'has-gap': textHasGap }">
        <div class="digit">
          {{ count }}
        </div>
        <div class="subline">{{ subline }}</div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

withDefaults(
  defineProps<{
    count?: number;
    subline?: string;
    isDark?: boolean;
  }>(),
  { count: 0, subline: 'cups per day' }
);

const { locale } = useI18n();

const textHasGap = computed(() => {
  return ['zh_cn', 'ja_jp'].includes(locale.value);
});
</script>

<style src="./EMShowroomCardSP.scss" lang="scss" scoped />
